<template lang="pug">
    v-dialog(v-model="dialog" width="700" persistent)
        template(v-slot:activator="{ on, attrs }")
            v-btn.ml-2(small color="primary" dark v-bind="attrs" v-on="on" @click="initForm")
                v-icon(small left) mdi-pencil
                | Edit
        v-card
            v-card-title Edit Campaign Survey
            v-card-text
                v-form(
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    :disabled="loading"
                )
                    v-text-field(
                        v-model="form.title"
                        :rules="titleRules"
                        label="Question Text"
                        required
                        dense
                        outlined
                    )
                    v-select(
                        v-model="form.type"
                        :items="['SCALE', 'BOOLEAN', 'MULTIPLE_CHOICE']"
                        label="Question Type"
                        outlined
                        dense
                    )
                    v-divider.mb-4
                    div.d-flex.align-center.mb-2
                        h3 Options
                        v-spacer
                        v-btn(small color="success" @click="addOption") Add Option
                    
                    v-row(v-for="(opt, index) in form.options" :key="index" align="center")
                        v-col(cols="4")
                            v-text-field(
                                v-model="opt.value"
                                label="Value (e.g. 1, 'yes')"
                                dense
                                outlined
                                hide-details
                            )
                        v-col(cols="7")
                            v-text-field(
                                v-model="opt.label"
                                label="Label (e.g. 'Not likely')"
                                dense
                                outlined
                                hide-details
                            )
                        v-col(cols="1")
                            v-btn(icon color="red" @click="removeOption(index)")
                                v-icon mdi-delete

            v-divider
            v-card-actions
                v-spacer
                v-btn(v-if="!loading" small color="red" text @click="dialog = false") Cancel
                v-btn(small color="primary" text @click="update" :loading="loading") Save Changes
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            valid: false,
            form: {
                title: '',
                type: 'SCALE',
                options: []
            },
            titleRules: [
                v => !!v || 'Question text is required'
            ],
        };
    },
    methods: {
        initForm() {
            this.form.title = this.item.title;
            this.form.type = this.item.type;
            
            let parsedOptions = [];
            try {
                if (typeof this.item.option_description === 'string') {
                    parsedOptions = JSON.parse(this.item.option_description);
                } else if (Array.isArray(this.item.option_description)) {
                    parsedOptions = [...this.item.option_description];
                }
            } catch (e) {
                console.error("Error parsing options:", e);
            }
            this.form.options = parsedOptions.map(opt => ({...opt}));
        },
        addOption() {
            this.form.options.push({ value: '', label: '' });
        },
        removeOption(index) {
            this.form.options.splice(index, 1);
        },
        async update() {
            if(this.$refs.form.validate()) {
                try {
                    this.loading = true;
                    // Format options before saving back to JSON string
                    const optionsJson = JSON.stringify(this.form.options);
                    
                    await this.updateItem([this.item.id, {
                        title: this.form.title,
                        type: this.form.type,
                        option_description: optionsJson
                    }]);
                    
                    this.$emit('success');
                    this.dialog = false;
                } catch(err) {
                    console.error(err);
                    this.$emit('error', err.message);
                } finally {
                    this.loading = false;
                }
            }
        },
        ...mapActions('bh-survey-options', { updateItem: 'patch' })
    }
}
</script>
